import React from 'react'

const DelayCertificateFooterRemark = () => (
  <section className="d-Delay-section">
    <h2 className="d-Delay-sectionTitle">ご利用上の注意</h2>
    <ul className="d-Delay-sectionList">
      <li className="d-Delay-sectionListItem">
        当証明書は、相鉄線の遅延のみを証明するものであり、遅延によりお客様に生じた損害等を賠償することを証明するものではありません。
      </li>
      <li className="d-Delay-sectionListItem">
        相鉄線で発生した最大の遅延時分を証明するものであり、個々の列車の遅延時分を証明するものではありません。また、お客様がご乗車されたことを証明するものではありません。
      </li>
      <li className="d-Delay-sectionListItem">
        相鉄線の各駅で発行している遅延証明書は、ホームページ遅延証明書の遅延時分とは異なることがあります。
      </li>
    </ul>
  </section>
)

export default DelayCertificateFooterRemark